import { ExportJsonData } from "src/UI/ExportButton/ExportButton";
import { utils, writeFile } from "xlsx";
import { columnFormats } from "../constants/constants";
import { withDownloadToast } from "./withDownloadToast";

export type ExportFieldMeta = { label: string; type: string };

function getXlsxFormatForType(type: string): string {
  const options = (
    columnFormats as { options?: { value: string; xlsx?: string }[] }[]
  ).flatMap((f) => f.options ?? []);
  const option = options.find((o) => o.value === type);
  return option?.xlsx ?? "@";
}

export async function exportJsonToExcel(
  data: ExportJsonData,
  fileName: string,
  fields?: ExportFieldMeta[]
) {
  const worksheet = utils.json_to_sheet(data);

  if (fields?.length) {
    const range = utils.decode_range(worksheet["!ref"] ?? "A1");
    const headerRow = range.s.r;
    const labelToType = new Map(fields.map((f) => [f.label, f.type]));

    for (let c = range.s.c; c <= range.e.c; c++) {
      const colLetter = utils.encode_col(c);
      const headerCell = worksheet[colLetter + (headerRow + 1)];
      const label = headerCell?.v as string | undefined;
      const type = label != null ? labelToType.get(String(label)) : undefined;
      const format = type ? getXlsxFormatForType(type) : "@";

      for (let r = headerRow + 1; r <= range.e.r; r++) {
        const cellRef = colLetter + (r + 1);
        const cell = worksheet[cellRef];
        if (cell && cell.t === "n") {
          cell.z = format;
        }
      }
    }
  }

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const filename = `${fileName}.xlsx`;
  await withDownloadToast(filename, () => writeFile(workbook, filename));
}
